import React, { useState } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import EditApplication from "./EditApplication";
import { ActiveCell } from "../GridComponents";
import { EditCommandCell, SignatureCell } from "../GridComponents";
import { useEffect } from "react";
import {
  updateApplication,
  useApplications,
} from "services/applicationService";
import { GridLoader } from "components/GridLoader";

const ApplicationsList = () => {
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState([]);
  const [editItem, setEditItem] = useState(null);
  const { data: applications, loading: isLoadingApplications } =
    useApplications();
  const enterEdit = (item) => {
    setIsEditFormOpen(true);
    setEditItem(item);
  };

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      await updateApplication(data.appCode, {
        appCode: data.appCode,
        appName: data.appName,
        active: data.active ?? true,
      });
      setIsEditFormOpen(false);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    if (applications !== null && applications !== undefined) {
      setData(applications);
    }
  }, [applications]);

  const handleCancelEdit = () => {
    setIsEditFormOpen(false);
    setEditItem(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid data={data} showLoader={isLoadingApplications} style={{ height: "100%" }}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
      >
        <GridNoRecords>
          {isLoadingApplications ? (
            <span></span>
          ) : (
            data && data?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column title=" " field="appCode" cell={SignatureCell} width="60px" />
        <Column field="appCode" title="App Code" width="120px" />
        <Column field="appName" title="App Name" width="200px" />
        <Column cell={ActiveCell} title="Active" width="50px" />
        <Column title="Edit" cell={MyEditCommandCell} width="40px" />
      </Grid>

      {isEditFormOpen && (
        <EditApplication
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          type="edit"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default ApplicationsList;
